module.exports = __webpack_public_path__ + "img/ascend_gold22.13067555.png";